export const DE = require('./text_de.json') as textBrick[]
export const FR = require('./text_fr.json') as textBrick[]
